.logOutBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('/lg_mountainBkgrd.jpg');
    background-size: cover;
    height: 100vh;
    width: 100%;
}

.logOutContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 9px;
    background-color: rgba(5, 38, 55, 0.43);
    width: 800px;
    height: 500px;
    flex-direction: column;
}

.logOutTitle {
    text-align: center;
    margin-bottom: 50px;
}
